// extracted by mini-css-extract-plugin
export default {"content":"Calltoaction_content__OvNTc","ctaBtn":"Calltoaction_ctaBtn__24wwF","left":"Calltoaction_left__f6o8Q","right":"Calltoaction_right__XnxNo"};